export { DetailsSensitiveArea } from './DetailsSensitiveArea';
